<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-select
                v-model="showRow[field]"
                v-if="lv_editable"
                :required="lv_required"
                :rules="rules"
                :validate-on-init="validateOnInit"

                :data="!!dataFunc&&!!showRow?dataFunc(showRow,rowIndex):data"
				:disabled-hide-on-click-outside="disabledHideOnClickOutside"
                :val-key="valKey"
                :label-key="labelKey"
                :multiple="multiple"
                :beforeSelect="!!beforeSelect?lv_beforeSelect:null"
                :afterSelect="!!afterSelect?lv_afterSelect:null"
                @select="val=$emit('select',{row,rowIndex,editRow,showRow})"/>

            <template v-else>
                <link-table-cell-normal
                    :render-func="renderFunc"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LinkSelect from "../../select/link-select";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: "link-table-column-select-item",
        components: {LvScopeSlot, LvColumnText, LinkSelect},
        mixins: [ColumnItemMixin],
        props: {
            data: {type: Array},
            valKey: {type: String, default: 'val'},
            labelKey: {type: String, default: 'name'},
            dataFunc: {type: Function,},
            beforeSelect: {type: Function},
            afterSelect: {type: Function},
            multiple: {type: Boolean, default: false},
			disabledHideOnClickOutside: {type: Boolean, default: false},    // 禁用点击外部的时候关闭弹出框
        },
        methods: {
            async lv_beforeSelect(val) {
                return await this.beforeSelect({val, row: this.showRow, rowIndex: this.rowIndex, field: this.field})
            },
            async lv_afterSelect(val) {
                return await this.afterSelect({val, row: this.showRow, rowIndex: this.rowIndex, field: this.field})
            }
        }
    }
</script>
